import React, { useEffect, useRef } from 'react';

interface IFootnoteProps {
    dark?: boolean;
    listType?: FootnoteListTypeEnum;
    id?: string;
    returnId?: string;
    children: React.ReactNode;
    onReturnClick?: () => void;
}

export enum FootnoteListTypeEnum {
    BULLET = 'bullet',
    DECIMAL = 'decimal'
}

export const Footnote: React.FC<IFootnoteProps> = ({
    dark,
    listType,
    id,
    returnId,
    children,
    onReturnClick
}) => {
    const ref = useRef(null);

    useEffect(() => {
        ref.current.addEventListener('dsdFootnoteReturnClick', () => {
            if (onReturnClick) onReturnClick();
        });
    }, []);

    return (
        <>
            {/*@ts-ignore*/}
            <dsd-footnote
                ref={ref}
                id={id}
                return-id={returnId}
                dark={dark}
                list-type={listType}
            >
                {children}
                {/*@ts-ignore*/}
            </dsd-footnote>
        </>
    );
};
